import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { TestSubsection } from "./TestSection";
import { Mail, Bell, RefreshCw } from "lucide-react";
import * as tests from "./testDefinitions";

export const AutomationSection = ({ testResults }) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg font-semibold">Automation & Alerts</CardTitle>
      </CardHeader>
      <CardContent className="space-y-6">
        <TestSubsection
          icon={Mail}
          iconColor="text-blue-600"
          title="Email Automation"
          tests={tests.emailAutomationTests}
          results={testResults.emailAutomation}
        />
        
        <TestSubsection
          icon={Bell}
          iconColor="text-orange-600"
          title="System Alerts"
          tests={tests.alertsTests}
          results={testResults.alerts}
        />
        
        <TestSubsection
          icon={RefreshCw}
          iconColor="text-green-600"
          title="Retry Logic"
          tests={tests.retryLogicTests}
          results={testResults.retryLogic}
        />
      </CardContent>
    </Card>
  );
};
